import { DataSource } from './DataSource';
import { CmsProperty } from '../../api/models/Shared.types';
import { CmsVodFilterRow } from '../../components/cms/CmsVodFilterRow';
import { Backend } from '../../api/Backend';

export class VodFilterDataSource extends DataSource {
  private tags: string[];
  pageProperties: string[];
  private filterCategory: boolean;
  private filterProductionYear: boolean;
  private filterRating: boolean;
  constructor(backend: Backend, pageProperties: string[], tags: string[]) {
    super(backend);
    this.tags = tags;
    this.filterCategory = pageProperties.includes(CmsProperty.VodFilterCategory);
    this.filterProductionYear = pageProperties.includes(CmsProperty.VodFilterProductionYear);
    this.filterRating = pageProperties.includes(CmsProperty.VodFilterRating);
    this.pageProperties = pageProperties;
  }

  override componentDescription() {
    return {
      focusable: true,
      type: CmsVodFilterRow,
      data: this,
    };
  }

  override load(): Promise<VodFilterDataSource> {
    return new Promise(resolve => {
      resolve(this);
    });
  }

  override isEmpty(): boolean {
    return !this.filterRating && !this.filterCategory && !this.filterProductionYear;
  }

  height(): number {
    return 60;
  }
}
